import React from 'react';
import { generateIcon } from '../generateIcon';

export const IconTwitterLogoFilled = generateIcon({
  name: 'TwitterLogoFilled',
  path: (
    <path d="M5 3C3.89543 3 3 3.89543 3 5V27C3 28.1046 3.89543 29 5 29H27C28.1046 29 29 28.1046 29 27V5C29 3.89543 28.1046 3 27 3H5ZM23.4785 8L17.5222 14.9238H17.5218L24 24.3516H19.2356L14.8732 18.0029L9.41155 24.3516H8L14.2466 17.0909L8 8H12.7644L16.8952 14.0118L22.0671 8H23.4785ZM14.956 16.2658L15.5889 17.171V17.1714L19.8997 23.3373H22.0677L16.7851 15.7811L16.1522 14.8758L12.0882 9.06259H9.92015L14.956 16.2658Z" />
  ),
});
